import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
	selectCmeForUserTeam,
	selectCmeUserTeam,
} from "reducers/securitySlice";
import { selectAdminPerson } from "../admin/adminSlice";
import { CME_APP_ID } from "../constants";

const initialState = {
	organisationId: null,
	appHierarchyId: CME_APP_ID,
};

const formTeamSlice = createSlice({
	name: "formTeam",
	initialState,
	reducers: {
		formTeamEdited(state, action) {
			//handle null form team return
			const formTeam = { ...initialState, ...action.payload };
			Object.entries(formTeam).forEach(([key, value]) => {
				state[key] = value;
			});
		},
	},
	extraReducers: {
		RESET_CME: () => {
			return initialState;
		},
	},
});

export const { formTeamEdited } = formTeamSlice.actions;

export const selectFormTeamId = (state) => state.cme.formTeam.organisationId;

export const selectDefaultFormTeam = createSelector(
	[selectCmeUserTeam],
	(teams) => {
		const defaultTeam = teams.find((t) => t.isDefault);
		return defaultTeam
			? {
					organisationId: defaultTeam.organisationHierarchyId,
					appHierarchyId: CME_APP_ID,
			  }
			: {
					organisationId: teams[0]?.organisationHierarchyId,
					appHierarchyId: CME_APP_ID,
			  };
	}
);

export const selectForUserDefaultFormTeam = createSelector(
	[selectCmeForUserTeam],
	(teams) => {
		const defaultTeam = teams.find((t) => t.isDefault);
		return defaultTeam
			? {
					organisationId: defaultTeam.organisationHierarchyId,
					appHierarchyId: CME_APP_ID,
			  }
			: {
					organisationId: teams[0]?.organisationHierarchyId,
					appHierarchyId: CME_APP_ID,
			  };
	}
);

export const selectFormTeam = createSelector(
	[
		(state) => state.cme.formTeam,
		selectDefaultFormTeam,
		selectForUserDefaultFormTeam,
		selectAdminPerson,
	],
	(formTeam, defaultFormTeam, forUserDefaultFormTeam, adminPerson) => {
		//if form has been saved previously, form team will be present
		//default form team is based on user's permissions
		return formTeam?.organisationId
			? formTeam
			: adminPerson?.personId
			? forUserDefaultFormTeam //if admin person is there, it means it's an admin acting on behalf - forUser defautls
			: defaultFormTeam; //otherwise we use current user's defaults
	}
);

export default formTeamSlice.reducer;
